export default __webpack_public_path__ + "3721d3cf5a901349a8f8e4c37027d4e5.png";